import {Component} from "@angular/core";

@Component({
  selector: 'fabric8-replicasets-list-toolbar',
  templateUrl: './list-toolbar.replicaset.component.html',
  styleUrls: ['./list-toolbar.replicaset.component.scss'],
})
export class ReplicaSetsListToolbarComponent {

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
